// extracted by mini-css-extract-plugin
export default {"spanAll":"Sym1jxCRkaP0DlM89whj"};